// Aviso para o PRÓPRIO professor cujo login não está ligado a um cadastro de
// professor: sem a ligação ele vê a lista de aulas vazia e acha que não tem
// turma (Arena Figueira, PROD, 16/10/2026). Melhor dizer o porquê e quem resolve.
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useTeacherLoginsWithoutRecord } from '@/hooks/useTeacherLoginLink';

export function ProfessorSemCadastroBanner() {
  const { t } = useTranslation();
  const { user, club } = useAuth();
  const { data } = useTeacherLoginsWithoutRecord({ enabled: !!user?.id });
  const meu = (data ?? []).some(l => l.user_id === user?.id && (!club?.id || l.club_id === club.id));
  if (!meu) return null;
  return (
    <div role="status" className="flex items-start gap-2 border-b bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-200">
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
      <span>{t('teachers.link.selfBanner')}</span>
    </div>
  );
}
